import GestaoOrcamentariaView from "../../components/gestaoOrcamentaria/GestaoOrcamentariaView";
import { getRoleFromToken } from "../../api";
import { DEPARTAMENTOS_DESPESAS_GERAIS, departamentosVisiveis } from "../../constants/departamentosOrcamento";

export default function DespesasGerais() {
  const departamentos = departamentosVisiveis(getRoleFromToken()).filter((d) => DEPARTAMENTOS_DESPESAS_GERAIS.includes(d));
  return <GestaoOrcamentariaView tituloModulo="Despesas Gerais" departamentos={departamentos} />;
}
